import { t } from "@lingui/macro";
import { I18nProvider } from "@lingui/react";
import { BlurView } from "expo-blur";
import { RelayEnvironmentProvider, useRelayEnvironment } from "react-relay";

import { StandardModal } from "@whoosh/design-system/src/components/overlay/StandardModal";
import { Box } from "@whoosh/design-system/src/components/primitive";

import { useAppliedLanguage } from "../../../features/LanguagePreference";
import { ProfileUpdateForm } from "../../../features/ProfileUpdateForm";
import { i18n } from "../../../utils/Translations/i18nBootstrap";
import {
  LaunchDarklyProvider,
  useParentLDContext,
} from "../../../utils/launchDarkly";

type OnboardingModalProps = {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
};
export const OnboardingModal = ({
  showModal,
  setShowModal,
}: OnboardingModalProps) => {
  /**
   * These are necessary to reflect as the modal uses portal which nukes context
   */
  const parentLDContext = useParentLDContext();
  const relayEnvironment = useRelayEnvironment();
  const appliedLanguage = useAppliedLanguage();

  return showModal ? (
    <BlurView
      blurMethod="dimezisBlurViewSdk31Plus"
      intensity={100}
      style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
      }}
    >
      <StandardModal
        isOpen={showModal}
        hideCloseButton
        content={
          <I18nProvider i18n={i18n} key={appliedLanguage}>
            <LaunchDarklyProvider parentLDContext={parentLDContext}>
              <RelayEnvironmentProvider environment={relayEnvironment}>
                <Box
                  bg="surface-primary"
                  height="100%"
                  testID="onboarding-profile-update-form"
                  accessibilityLabel={t`profile update form while onboarding`}
                >
                  <ProfileUpdateForm
                    submitNavigate={() => setShowModal(false)}
                    isOnboarding={true}
                  />
                </Box>
              </RelayEnvironmentProvider>
            </LaunchDarklyProvider>
          </I18nProvider>
        }
      />
    </BlurView>
  ) : null;
};
